import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { MaintenanceIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';
import { useTranslate } from 'src/locales';
import { Alert } from '@mui/material';

type OwnProps = {
  error?: string;
  stack?: string;
  onRetry: () => void;
};

export function RuntimeError({ error, onRetry, stack }: OwnProps) {
  const { t } = useTranslate();

  return (
    <Container component={MotionContainer} textAlign="center">
      <m.div variants={varBounce('in')}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          {t('errors.runtimeError')}
        </Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <Alert severity="error">
          <Typography variant="h6">{error}</Typography>
          <Typography variant="caption">{stack}</Typography>
        </Alert>
      </m.div>

      <m.div variants={varBounce('in')}>
        <MaintenanceIllustration sx={{ my: { xs: 5, sm: 10 } }} />
      </m.div>

      <Button onClick={onRetry} size="large" variant="contained">
        {t('buttons.goHome')}
      </Button>
    </Container>
  );
}
